/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Edit, ArrowBack } from "@mui/icons-material";
import { getAboutStatsById, deleteAboutStats } from "actions/aboutStats";
import { clearError, clearAboutStat } from "features/aboutStatsSlice";
import { ADMIN_TEXTS } from "constants/adminTexts";
import { PATHNAME } from "constants/pathnames";
import "./About.scss";
import { BrandButton } from "components/brand";

export const AboutStatsDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: null,
  });

  const { aboutStat, loading, deleteLoading, error } = useSelector(
    (state) => state.aboutStats,
  );

  const handleEdit = () => {
    navigate(`${PATHNAME.aboutStats}/${id}/edit`);
  };

  const handleDeleteClick = () => {
    setDeleteDialog({
      open: true,
      id,
    });
  };

  const handleDelete = () => {
    dispatch(deleteAboutStats({ id: deleteDialog.id }));
    setDeleteDialog({ open: false, id: null });
    navigate(PATHNAME.aboutStats);
  };

  const handleBack = () => {
    navigate(PATHNAME.aboutStats);
  };

  useEffect(() => {
    if (id) {
      dispatch(getAboutStatsById({ id }));
    }
    return () => {
      dispatch(clearAboutStat());
    };
  }, [id]);

  useEffect(() => {
    if (error) {
      dispatch(clearError());
    }
  }, [error]);

  if (loading) {
    return (
      <Box className="loading-container">
        <CircularProgress />
      </Box>
    );
  }

  if (!aboutStat) {
    return (
      <Box className="about-stats-detail">
        <Alert severity="error">{ADMIN_TEXTS.aboutStats.statNotFound}</Alert>
      </Box>
    );
  }

  return (
    <Box className="about-stats-detail">
      <Box className="detail-header">
        <BrandButton
          variant="secondary"
          startIcon={<ArrowBack />}
          onClick={handleBack}
          className="back-button"
        >
          {ADMIN_TEXTS.common.back}
        </BrandButton>
        <Typography variant="h4" component="h1" fontWeight="bold">
          {ADMIN_TEXTS.aboutStats.statDetails}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Box className="detail-content">
                <Box className="detail-section">
                  <Typography variant="h6" className="detail-label">
                    {ADMIN_TEXTS.aboutStats.name}
                  </Typography>
                  <Typography variant="body1" className="detail-value">
                    {aboutStat.name}
                  </Typography>
                </Box>

                <Box className="detail-section">
                  <Typography variant="h6" className="detail-label">
                    {ADMIN_TEXTS.aboutStats.value}
                  </Typography>
                  <Typography variant="h4" className="detail-value stat-value">
                    {aboutStat.value}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Box className="detail-actions">
                <BrandButton
                  variant="primary"
                  startIcon={<Edit />}
                  onClick={handleEdit}
                  fullWidth
                  className="edit-button"
                >
                  {ADMIN_TEXTS.common.edit}
                </BrandButton>
                <BrandButton
                  variant="error"
                 
                  onClick={handleDeleteClick}
                  disabled={deleteLoading}
                  fullWidth
                  className="delete-button"
                >
                  {ADMIN_TEXTS.common.delete}
                </BrandButton>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, id: null })}
      >
        <DialogTitle>{ADMIN_TEXTS.aboutStats.deleteStat}</DialogTitle>
        <DialogContent>
          <Typography>
            {ADMIN_TEXTS.aboutStats.confirmDelete}?{" "}
            {ADMIN_TEXTS.aboutStats.deleteConfirmMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <BrandButton
            variant="secondary"
            onClick={() => setDeleteDialog({ open: false, id: null })}
            color="primary"
          >
            {ADMIN_TEXTS.common.cancel}
          </BrandButton>
          <BrandButton onClick={handleDelete} variant="error">
            {ADMIN_TEXTS.common.delete}
          </BrandButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
